import { createContext, useContext } from "react";

import type { Policy } from "../api/rpc";
import type { AuthInfo } from "../api/types";

export interface AuthSession {
  info: AuthInfo;
  policies: Policy[];
}

export interface AuthState {
  /** `loading` until `auth.info` has resolved once. */
  status: "loading" | "authenticated" | "anonymous" | "error";
  session: AuthSession | null;
  error: Error | null;
  /** Abilities for a record id taken from the `auth.info` policies array. */
  abilitiesFor: (id: string | undefined) => Record<string, boolean>;
  /** Abilities on the workspace itself, e.g. `createCollection`. */
  teamAbilities: Record<string, boolean>;
  refresh: () => void;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const value = useContext(AuthContext);
  if (value === null) {
    throw new Error("useAuth must be used inside <AuthProvider>");
  }
  return value;
}
